import { getShowCompactEventPage } from "@Modules/eventPage/components/CompactEventPage/utils/getShowCompactEventPage";
import React from "react";
import { useEarlyBirdClock } from "../../EarlyBird/utils/useEarlyBirdClock";
import { IPaymentSummary } from "../IPaymentSummary";
import ExpandCollapseButton from "./ExpandCollapseButton/ExpandCollapseButton";

const ExpandButton = ({
    isMobile,
    expandButtonCtaText,
    disablePaymentSummaryExpanding,
    customerHasSelectedItemsForSummary,
    showEarlyBirdClock,
    earlyBirdTime,
    urlQueryParams,
}: IPaymentSummary.IExpandButtonProps) => {
    const earlyBirdClock = useEarlyBirdClock(earlyBirdTime);

    const showCompactEventPage = getShowCompactEventPage({
        urlQueryParams,
    });

    const hideComponent =
        disablePaymentSummaryExpanding &&
        (showCompactEventPage || // hide on compact page
            (!showCompactEventPage && !isMobile) || // hide on normal event page's desktop view
            (!showCompactEventPage &&
                isMobile &&
                (!customerHasSelectedItemsForSummary || !showEarlyBirdClock))); // hide for normal event page's mobile view if no early bird timer exists or no offering selected(no slot picked / so schedule selected)

    if (hideComponent) return null;

    return (
        <ExpandCollapseButton
            expanded={false}
            expandDirection={!isMobile ? "down" : "up"}
            toggleState={() => {}}
            text={
                showEarlyBirdClock && isMobile
                    ? earlyBirdClock
                    : expandButtonCtaText
            }
        />
    );
};

export default ExpandButton;
